<template>
    <v-card>
        <v-card-title class="sticky">
            アラート一覧
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex v-if="isSearching()">
                        <v-btn class="primary mr-2" @click="openDialog">検索</v-btn>
                        <v-btn class="error mr-2" @click="resetSearch">検索リセット</v-btn>
                    </v-flex>
                    <v-flex v-else>
                        <v-btn @click="openDialog">検索</v-btn>
                    </v-flex>
                    <v-flex class="text-right">
                        <v-btn class="info" @click="loadList()">最新情報を表示する</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="alerts"
                :options.sync="options"
                :server-items-length="alerts.length"
                :loading="loading"
                hide-default-footer
                class="elevation-1"
            >
                <template v-slot:[`item.action`]="{ item }">
                    {{showAction(item.alert_id)}}
                </template>
                <template v-slot:[`item.kind`]="{ item }">
                    {{showKind(item.alert_id)}}
                </template>
                <template v-slot:[`item.instruction`]="{ item }">
                    {{showInstruction(item.alert_id)}}
                </template>
                <template v-slot:[`item.buttons`]="{ item }">
                    <v-btn fab small class="mr-2" :to="`customer/${item.customer_id}`" target="_blank">
                        カルテ
                    </v-btn>
                    <v-btn fab small class="mr-2" :to="`customer/history/${item.customer_id}?id=${item.history_id}`" target="_blank">
                        経緯表
                    </v-btn>
                    <v-btn fab small class="info mr-2" @click="done(item.id)" :disabled="!item.is_complete">
                        完了
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>

        <v-layout row justify-center>
            <v-dialog v-model="searchDialog" persistent max-width="800px">
                <v-form>
                    <v-card>
                        <v-card-title>
                            <span class="headline">アラート検索</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md3 v-if="canSearchShop()">
                                        <v-select
                                            v-model="conditions.shop_id"
                                            :items="searchShops"
                                            label="支店"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3 v-if="canSearchCO()">
                                        <v-select
                                            v-model="conditions.counselor_id"
                                            :items="searchCounselors"
                                            label="担当CO"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.gender"
                                            :items="searchGenders"
                                            label="性別"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                class="info"
                                @click="search"
                                >検索</v-btn
                            >
                            <v-btn @click="closeDialog">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<style scoped>
.sticky{
    position: sticky;
    top: 64px;
    background-color: #fff;
    z-index: 1;
    box-shadow: 0px 2px 2px 0px rgb(0 0 0 / 14%);
}
@media screen and (max-width:960px) {
    .sticky{
        top: 56px;
    }
}
</style>
<script>
import ACCOUNT from "@/consts/account.js";
import CUSTOMER from "@/consts/customer.js";

export default {
    title: "アラート一覧",
    name: "alert",
    data: () => ({
        alertMaster: [],
        alerts: [],
        loading: true,
        options: {},
        headers: [
            { text: "No.", value: "id", align: "start", sortable: false },
            { text: "担当CO", value: "counselor_name", align: "start", sortable: false },
            { text: "行動区分", value: "action", align: "start", sortable: false },
            { text: "取組区分", value: "kind", align: "start", sortable: false },
            { text: "期限", value: "target_date", align: "start", sortable: false },
            { text: "対象会員№", value: "target_customer.number", align: "start", sortable: false },
            { text: "対象会員", value: "target_customer.name", align: "start", sortable: false },
            { text: "行動", value: "instruction", align: "start", sortable: false },
            { text: "", value: "buttons", align: "right", sortable: false },
        ],
        searchDialog: false,
        conditions: {
            shop_id: 0,
            counselor_id: 0,
            gender: 0,
        },
        searchShops: [],
        searchCounselors: [],
        searchGenders: [],
    }),
    watch: {
        options: {
            handler() {
                this.loadList();
            },
            deep: true,
        },
    },
    async mounted() {
        // 検索条件の読み込み
        this.loadSearchConditions();
    },
    methods: {
        showAction(id) {
            const alert = this.alertMaster.find(alert => alert.id == id);
            if(!alert) return '';
            switch(alert.action){
                case 1: return "入力する";
                case 2: return "手紙送付";
                case 3: return "日付確認";
                case 4: return "確認TEL";
                case 5: return "報告TEL";
                case 6: return "フォローTEL";
            }
            return "";
        },
        showKind(id) {
            const alert = this.alertMaster.find(alert => alert.id == id);
            if(!alert) return '';
            switch(alert.kind){
                case 1: return "担当CO確定";
                case 2: return "お礼の手紙送付";
                case 3: return "第1回CO";
                case 4: return "第2回CO";
                case 5: return "第3回CO";
                case 6: return "結果入力";
                case 7: return "相手選後フォロー1";
                case 8: return "相手選後フォロー2";
                case 9: return "相手選び";
                case 10: return "次回CO日時確定";
                case 12: return "お見合";
                case 13: return "デート";
                case 14: return "デート後フォロー1";
                case 15: return "デート後フォロー2";
                case 16: return "交際報告来社";
                case 17: return "カウンセリング";
            }
            return "";
        },
        showInstruction(id) {
            const alert = this.alertMaster.find(alert => alert.id == id);
            if(!alert) return '';
            return alert.instruction;
        },
        async loadList() {
            this.loading = true;
            try {
                const result = await this.$axios
                    .get(`/api/v1/alert/`, {
                        params: {
                            shop_id: this.conditions.shop_id,
                            counselor_id: this.conditions.counselor_id,
                            gender: this.conditions.gender,
                        }
                    })
                    .then((response) => {
                        return response.data;
                    });
                
                if(result) {
                    this.alerts = result.alerts;
                    this.alertMaster = result.alertMaster
                    
                    this.searchShops = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.shops.forEach(shop => this.searchShops.push({ value: shop.id, text: shop.name}));
                    this.searchCounselors = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.counselors.forEach(c => this.searchCounselors.push(c));
                    this.searchGenders = [{
                        value: 0,
                        text: "全て"
                    }];
                    CUSTOMER.GENDER.LIST.forEach(g => this.searchGenders.push(g));
                }
            } catch (error) {
                console.log(error);
            }
            this.loading = false;
        },
        async done(id){
            this.$axios
                .delete(`/api/v1/alert/${this.$store.state.user.id}/${id}`)
                .then((response) => {
                    console.log("Done : id=" + response.data.id);
                })
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.loadList();
                });
        },
        canSearchShop() {
            const self = this.$store.state.user;
            
            // システム管理者は店舗検索可能
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) != 0) return true;
            // アラート全体は店舗検索可能
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.ALERT_ALL) != 0) return true;

            return false;
        },
        canSearchCO() {
            const self = this.$store.state.user;
            
            // システム管理者は店舗検索可能
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) != 0) return true;
            // アラート全体は店舗検索可能
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.ALERT_ALL) != 0) return true;
            // アラート店舗は担当CO検索可能
            if((self.privilege & ACCOUNT.PRIVILEGE.VAL.ALERT_SHOP_ALL) != 0) return true;

            return false;
        },
        loadSearchConditions() {
            this.conditions = Object.assign({}, this.$store.state.alertConditions);
        },
        isSearching() {
            if(this.$store.state.alertConditions.shop_id != 0) return true;
            if(this.$store.state.alertConditions.counselor_id != 0) return true;
            if(this.$store.state.alertConditions.gender != 0) return true;
            return false;
        },
        search() {
            this.$store.dispatch("setAlertSearchConditions", this.conditions);
            this.closeDialog();
            this.$router.go({path: "/alert", force: true})
        },
        resetSearch() {
            this.conditions = {
                shop_id: 0,
                counselor_id: 0,
                gender: 0,
            };
            this.search();
        },
        openDialog() {
            this.loadSearchConditions();
            this.searchDialog = true;
        },
        closeDialog() {
            this.searchDialog = false;
        },
    },
};
</script>
